import { render, staticRenderFns } from "./promocode.vue?vue&type=template&id=b89f3d1c&scoped=true"
import script from "./promocode.vue?vue&type=script&lang=js"
export * from "./promocode.vue?vue&type=script&lang=js"
import style0 from "./promocode.vue?vue&type=style&index=0&id=b89f3d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89f3d1c",
  null
  
)

export default component.exports